const tabletConstants = {
  FETCH: 'FETCH_TABLET',
  UPDATE: 'UPDATE_TABLET',
};


export default tabletConstants;
